import { basicEnum } from "./base";

export const ONTTaskEnum = basicEnum([
    {
        label: "FORCE DUMP",
        value: "00_FORCE_DUMP",
    },
    {
        label: "INIT",
        value: "01_INIT",
    },
    {
        label: "DUMP",
        value: "02_DUMP",
    },
    {
        label: "REFRESH",
        value: "03_REFRESH",
    },
    {
        label: "REBOOT",
        value: "04_REBOOT",
    },
]);

export namespace ONTTaskEnum {
    export type Labels = (typeof ONTTaskEnum)["labels"][number];
    export type Values = (typeof ONTTaskEnum)["values"][number];
}
